import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables';
import React from 'react';
import styled from 'styled-components';

import {ITestimonial} from '../data/customerData';

import {pxToEm} from './globalStyles';

//#region Styled Components

const quotesPaddingPx = 50;
const avatarSizePx = 56;
const avatarBorderRadius = '8px';

const StyledWrapperDiv = styled.div`
  position: relative;
  width: 100%;
  margin-top: ${pxToEm(avatarSizePx / 2)}em;
`;

const StyledPersonPlateDiv = styled.div`
  position: absolute;
  top: ${pxToEm(-avatarSizePx / 2)}em;
  left: ${pxToEm(quotesPaddingPx)}em;
  display: flex;

  background-color: white;
  box-shadow: 0 0 5px rgba(51, 133, 227, 0.22);
  border-radius: ${avatarBorderRadius} 4px 4px ${avatarBorderRadius};
`;

const StyledAvatarImg = styled.img`
  width: ${pxToEm(avatarSizePx)}em;
  height: ${pxToEm(avatarSizePx)}em;
  border-radius: ${avatarBorderRadius};
`;

const StyledPersonDataDiv = styled.div`
  padding: ${pxToEm(7)}em ${pxToEm(25)}em;
`;

const StyledNameDiv = styled.div`
  font-size: ${pxToEm(16)}em;
  font-weight: bold;
  color: ${baseVariables.colors.midnight};
  margin-bottom: ${pxToEm(10) / pxToEm(16)}em;
`;

const StyledPositionAndCompanyDiv = styled.div`
  font-size: ${pxToEm(14)}em;
`;

const StyledQ = styled.q`
  display: block;
  font-size: ${pxToEm(17)}em;
  line-height: 2;
  background-color: ${baseVariables.colors.lightBlueGray};
  padding: ${pxToEm(quotesPaddingPx)}em;
  text-align: justify;

  :not(:last-child) {
    margin-bottom: 0.5em;
  }
`;

//#endregion

interface Props {
  testimonial: ITestimonial;
}

const Testimonial: React.FunctionComponent<Props> = ({testimonial}) => (
  <StyledWrapperDiv>
    <StyledPersonPlateDiv>
      {testimonial.avatarPath && <StyledAvatarImg src={testimonial.avatarPath} alt={`${testimonial.name} avatar`} />}
      <StyledPersonDataDiv>
        <StyledNameDiv>{testimonial.name}</StyledNameDiv>
        <StyledPositionAndCompanyDiv>
          {testimonial.position}, {testimonial.company}
        </StyledPositionAndCompanyDiv>
      </StyledPersonDataDiv>
    </StyledPersonPlateDiv>
    <StyledQ>{testimonial.quote}</StyledQ>
  </StyledWrapperDiv>
);

export default Testimonial;
